export const structure = () => {
    return {
        data: [],
        newLogs: '',
        oldLogs: '',
        noOldLogs: false,
        lastCall: ''
    }
}

export default {
    logs: {},
    members: {},
    newLogs: '',
    oldLogs: '',
    lastCalled: '',
    cacheTime: 30000
}
